import { inject, Injectable } from '@angular/core';

import { Observable, of, switchMap } from 'rxjs';

import { injectTranslate } from '@core/i18n-legacy';
import { AddMemberAction } from '@core/tellent-types';
import { DialogService, DialogWidth, RtPlatform } from '@core/user-interface-legacy';

import { AddMemberService } from '../add-member-dialog/add-member.service';
import { AddMemberFlowChoiceDialogComponent } from '../add-member-flow-choice-dialog/add-member-flow-choice-dialog.component';
import { StartPreonboardingJourneyService } from '../start-preonboarding-journey-dialog/start-preonboarding-journey.service';

@Injectable({
  providedIn: 'root',
})
export class AddMemberMultiStepService {
  private readonly dialogService = inject(DialogService);
  private readonly platform = inject(RtPlatform);
  private readonly t = injectTranslate();

  private readonly addMemberService = inject(AddMemberService);
  private readonly startPreonboardingJourneyService = inject(StartPreonboardingJourneyService);

  public startProcess(): Observable<any> {
    return this.dialogService
      .openDialog(
        AddMemberFlowChoiceDialogComponent,
        {},
        {
          width: DialogWidth.Small,
          mobileOptions: this.platform.IS_MOBILE
            ? {
                mobileDialog: true,
                mobileViewTitle: this.t('tlc.assign_members_to_jobs.dialog.mobile_heading'),
              }
            : undefined,
        },
      )
      .afterClosed.pipe(
        switchMap(stepOneResult => {
          if (!stepOneResult) {
            return of(null); // Handle case where the first dialog is closed without action
          }

          switch (stepOneResult.action) {
            case AddMemberAction.InviteMember:
              return this.handleInviteMemberFlow(stepOneResult);
            case AddMemberAction.AddEmployeeForPreonboarding:
              return this.handleStartPreonboardingJourneyFlow(stepOneResult);
            case AddMemberAction.AddEmployeeWithoutAccess:
              return this.handleAddEmployeeListedOnlyFlow(stepOneResult);
            default:
              return of(null); // Handle unexpected actions
          }
        }),
      );
  }

  private handleInviteMemberFlow(data: any): Observable<any> {
    return this.addMemberService.startInviteMemberFlow();
  }

  private handleStartPreonboardingJourneyFlow(data: any): Observable<any> {
    return of(true);
    // return this.startPreonboardingJourneyService.startPreonboardingJourneyFlow();
  }

  private handleAddEmployeeListedOnlyFlow(data: any): Observable<any> {
    return of('flow3');
  }
}
